import api from '../api'
import {fetchQuestionPolls,fetchSetPolls} from './polls'
import * as Sentry from '@sentry/browser'


export function fetchSection(sectionId) {
  	return (dispatch) => api.fetch(`/sections/${sectionId}?populated=true`)
	    .then((response) => {
		      dispatch({ type: 'FETCH_SECTION_SUCCESS', response })
	    })
	     .catch(err => {
         	
		})
	
}

 
export function fetchSections() {
 	return (dispatch) => api.batchedFetch('/sections?archived=false&populated=true')
	    .then((response) => {
		      dispatch({ type: 'FETCH_All_SECTIONS_SUCCESS', response })
		      return response
	    })
	     .catch(err => {
         	
		})

}

export function fetchArchivedSections() {
 	return (dispatch) => api.batchedFetch('/sections?archived=true&populated=true')
	    .then((response) => {
		      dispatch({ type: 'FETCH_ARCHIVED_SECTIONS_SUCCESS', response })
	    })
	     .catch(err => {
         	
		})

}


export function newSection(data) {
  	return (dispatch) => api.post('/sections/',data)
	    .then((response) => {
		      dispatch({ type: 'CREATE_SECTION_SUCCESS', response})
		      dispatch({ type: 'HIDE_MODAL' })
		      return response
	    })
	    .catch(err => {
	       Sentry.withScope(scope => {
				scope.setExtra('request', data)
				Sentry.captureException(new Error(err))
			})
		})
}
 
export function deleteSection(sectionId) {
  	return (dispatch) => api.delete(`/sections/${sectionId}`)
	    .then((response) => {
		      dispatch({ type: 'DELETE_SECTION_SUCCESS', sectionId})
	    })
	     .catch(err => {
	       Sentry.withScope(scope => {
				scope.setExtra('request', sectionId)
				Sentry.captureException(new Error(err))
			})
		})
}

export function updateSection(data,sectionId) {
  	return (dispatch) => api.put(`/sections/${sectionId}`,data)
	    .then((response) => {
		      dispatch({ type: 'UPDATE_SECTION_SUCCESS', response})
		      return response
	    })
	     .catch(err => {
	       Sentry.withScope(scope => {
				scope.setExtra('request', data)
				Sentry.captureException(new Error(err))
			})
		})
}

export function archiveSection(data,sectionId) {
  	return (dispatch) => api.put(`/sections/${sectionId}`,data)
	    .then((response) => {
		      dispatch({ type: 'ARCHIVE_SECTION_SUCCESS', response})
		      return response
	    })
	     .catch(err => {
		})
}

export function unarchiveSection(data,sectionId) {
  	return (dispatch) => api.put(`/sections/${sectionId}`,data)
	    .then((response) => {
			dispatch({ type: 'UNARCHIVE_SECTION_SUCCESS', response})
			dispatch(fetchSection(response.id))
			dispatch({ type: 'CLEAR_QUESTION_POLLS_REFRESHED_TIMESTAMP'})
			dispatch({ type: 'CLEAR_SET_POLLS_REFRESHED_TIMESTAMP'})
			dispatch(fetchQuestionPolls())
			dispatch(fetchSetPolls())
		      return response
	    })
}



export function updateSectionPreferences(data,sectionId) {
  	return (dispatch) => api.put(`/sections/${sectionId}/preferences`,data)
	    .then((response) => {
		     dispatch({ type: 'UPDATE_SECTION_SUCCESS', response})
	    })
	     .catch(err => {
	       Sentry.withScope(scope => {
				scope.setExtra('request', data)
				Sentry.captureException(new Error(err))
			})
		})

}





// WEBPACK FOOTER //
// ./src/actions/sections.js